export default "__VITE_ASSET__42b38b5d__"